export default "__VITE_ASSET__C_ktTv05__";